export const fabricsConfig = {
	apiKey: "AIzaSyD8Ii1AV03jh-dWXodATzwBqSZPoOY0Ab8",
    authDomain: "project-fabrics.firebaseapp.com",
    projectId: "project-fabrics",
    storageBucket: "project-fabrics.appspot.com",
    messagingSenderId: "9790315116",
    appId: "1:9790315116:web:b1abe785c4b9c27ebd5649",
    measurementId: "G-9M5YXQFH29"
};